import groq from 'groq';
import { getConfig } from '@/constants/config';
import { CONTENT_BLOCK_GROUP_PROJECTION } from '@/integrations/sanity/api/projections';
import { sanityFetch } from '@/integrations/sanity/client';
import type { TERMS_AND_CONDITIONS_QUERY_RESULT } from '@/integrations/sanity/sanity.types';

const TERMS_AND_CONDITIONS_QUERY = groq`*[_type == "termsContent" && locale == $locale][0] {
  id,
  _type,
  lastUpdatedTitle,
  contentBlockGroup ${CONTENT_BLOCK_GROUP_PROJECTION} 
}`;

export const getTermsAndConditions = () =>
  sanityFetch<TERMS_AND_CONDITIONS_QUERY_RESULT>(TERMS_AND_CONDITIONS_QUERY, {
    locale: getConfig().locale,
  });
